import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=f5217038&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5217038')) {
      api.createRecord('f5217038', component.options)
    } else {
      api.reload('f5217038', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=f5217038&", function () {
      api.rerender('f5217038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2caR9Div76bWR/JS/cancellationPolicy.vue"
export default component.exports